import React, { Component } from 'react';

import ExportButton from '../../common/components/export-button';
import LoadingSpinner from '../../common/components/loading-spinner';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { exportToPdf } from '../actions/export-report-action-creators';
import { isFetchingPdfSelector } from '../selectors/reports-selectors';

export class ExportToPdfContainer extends Component{
    render(){
        const { automationId, exportToPdf, isFetchingPdf } = this.props;
        return (
            <React.Fragment>
                {
                    isFetchingPdf ? (
                        <div style={{ 'float': 'right' }}>
                            <LoadingSpinner size="small" />
                        </div>
                    ) : (
                        <ExportButton
                            automationId={automationId}
                            exportText="Export to PDF"
                            exportType={exportToPdf}
                        />
                    )}
            </React.Fragment>
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        isFetchingPdf: isFetchingPdfSelector( state )
    };
};

ExportToPdfContainer.propTypes = {
    automationId: PropTypes.string,
    exportToPdf: PropTypes.func,
    isFetchingPdf: PropTypes.bool
};

export default connect( mapStateToProps, { exportToPdf } )( ExportToPdfContainer );
